module.exports = __webpack_public_path__ + "img/unica-logo-no-bg.97079cb5.png";